// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div#marketing-page[data-v-d1db9498]{height:100vh}a#study-redirect-link[data-v-d1db9498]{color:silver}@media (max-width:600px){div.v-alert[data-v-d1db9498]{font-size:.8rem}}", ""]);
// Exports
module.exports = exports;
